import React, { useEffect, useState } from "react";
import { notify } from "../components/Toast/Toast";

export function Dashboard({ goodName }) {
  const [active, setActive] = useState({});

  function fetchActive() {
    fetch(`https://inventy.redata.se/inventdb/api_dash.php`)
      .then((response) => response.json())
      .then((data) => {
        setActive(data[0]);
        console.log(data[0]);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }

  useEffect(() => {
    fetchActive();
  }, []);
  return (
    <div style={{ width: "70%", minWidth: "300px", margin: "auto" }}>
      <div className="Widget">
        <h1>Pågående Inventering</h1>
        {active ? (
          <div
            style={{
              margin: "20px",
              width: "100%",
              borderRadius: "15px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              backgroundColor: "var(--background-color)",
              padding: "10px",
            }}
          >
            <h3>{active.Name}</h3>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "left",
              }}
            >
              <div>
                <p>Totalt värde: </p>
                <p>Startdatum:</p>
                <p>Barer Inventerade:</p>
              </div>
              <div style={{ textAlign: "right", fontWeight: "bold" }}>
                <p>{active.Value + " kr"}</p>
                <p>{active.date}</p>
                <p>{active.barAmount}</p>
              </div>
            </div>
            <button
              onClick={() => goodName(active.ID)}
              style={{ marginTop: "20px" }}
            >
              Öppna
            </button>
          </div>
        ) : (
          <>
            <h3>ingen öppen inventering</h3>
            <button onClick={() => goodName("new")}>Skapa</button>
          </>
        )}
      </div>
      <button onClick={()=>{notify("warning")}}>Warning</button>
      <button onClick={()=>{notify("error")}}>Error</button>
      <button onClick={()=>{notify()}}>Success</button>
      
    </div>
  );
}
